/**
 * Su maistu besiliečiančių medžiagų (MBM) kilmės regionas.
 * Atspindi backend `OKIS.Domain.Shared.Activities.MbmOriginRegion` enum.
 * Saugoma kaip `int[]` PostgreSQL stulpelyje `activity.mbm_origin_regions`.
 */
export enum MbmOriginRegion {
	EuEea = 1,
	NonEuEea = 2,
}
